module.exports = __webpack_public_path__ + "img/add_btn_icon471.35eeae32.svg";